import { Updater } from 'use-immer';
import { FormValues } from '@linktivity/link-ui';
import { IOption } from '@sagano/share/services/types';
import { AgentType, IRole, SERVICE_DATE_RANGE } from '../../services/const';
import { today, getTodayAfterDays } from '../../utils';

export interface BookingListSearchFiltersProps {
  filters: FormValues;
  onSubmit: (filters: FormValues) => void;
  onFiltersChange?: Updater<FormValues>;
  asyncOptions?: Record<string, IOption[]>;
  role: IRole;
  forSales?: boolean;
}

export const commonFilters: FormValues = {
  submittedAtFrom: '',
  submittedAtTo: '',
  get serviceDateFrom() {
    return today();
  },
  get serviceDateTo() {
    return getTodayAfterDays(SERVICE_DATE_RANGE);
  },
  bookingId: '',
  agentSubGroupIds: '',
  groupTypes: '',
  groupName: '',
  status: [],
  notificationMsg: ''
};

export const adminBookingFilters: FormValues = {
  ...commonFilters,
  agentId: '',
  subStatus: [],
  countryCode: '',
  paymentType: '',
  contract: AgentType.Free
};
export const adminSalesFilters: FormValues = {
  ...adminBookingFilters,
  paymentStatus: []
};
export const agentSalesFilters: FormValues = {
  ...commonFilters,
  paymentStatus: []
};
